module.exports = __webpack_public_path__ + "media/900_SERF_2022_TargetedThreats.361ab887.mp4";